/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2023 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Auth home Loading card skeleton
 *
 * @file LoadingCard.jsxs
 * @author Samuel S Gladson
 */

import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer';
import CommonUtils from '../../../common/utils/CommonUtils';
import {
  ChannelsSliderLoader,
  CourseSectionLoader,
  HeaderLoader,
  HeroGenericShimmer
} from './ComponentLoader';
import * as constants from '../../../common/constants';
import FooterIllustration from '../FooterIllustration';
import Container from '../../../common/components/Container';
import './loader.scss';

const LoadingCard = ({ location = constants.AUTH_HOME }) => {
  const footerMenuList = CommonUtils.footerMenuList(CommonUtils.isGhostAccount(), true);

  return (
    <div
      style={{ background: '#E8E6F3', height: '100%' }}
      className="one-reader-maincontainer"
    >
      <HeaderLoader />
      <div className="one-reader-content-wrapper">
        {location === constants.AUTH_HOME
          ? (
            <Container
              enableGutters
              enableTopAndBottomPadding
            >
              <CourseSectionLoader />
            </Container>
          )
          : null}
        <Container
          enableGutters
          enableTopAndBottomPadding
        >
          <HeroGenericShimmer withoutWrapper />
        </Container>
      </div>
      <div className="popular-channel-wrapper">
        <Container
          enableGutters
          enableTopAndBottomPadding
        >
          <ChannelsSliderLoader />
        </Container>
      </div>
      <Footer {...footerMenuList} />
    </div>
  );
};


export default LoadingCard;
